<template>
  <li class="single-timeline-event">
    <div :class="{'direction-l': indexKey % 2 == 0, 'direction-r': indexKey % 2 != 0}">
      <div class="flag-wrapper">
        <span class="hexa" ></span>
        <span class="flag">{{ singleEvent.event_action ? `${singleEvent.event_action.charAt(0).toUpperCase()}${singleEvent.event_action.slice(1)}${singleEvent.event_action == 'add' ? 'ed' : 'd'} - ` : ''}} {{ singleEvent.event_name }} </span>
        <span class="time-wrapper" ><span class="time" :style="{ backgroundColor: singleEvent.color_code}">{{ moment(singleEvent.event_time).utc().format('DD-MM-YYYY, h:mm a') }} UTC <br><br> {{ moment(singleEvent.event_time).format('DD-MM-YYYY, h:mm a') }} YOUR LOCAL </span></span>
      </div>
      <div class="desc">
          <h5>{{ singleEvent.event_name }}  {{ singleEvent.event_action ? `- ${singleEvent.event_action}` : ''}} </h5>


          <div v-if="singleEvent.event_type=='tag-changes'">
            <p><strong>Current Tags :</strong>{{ singleEvent.current_tags }}</p>
            <p><strong>Previous Tags :</strong>{{ singleEvent.previous_tags }}</p>
          </div>

         <div v-if="singleEvent.event_type=='tracking-id'">
            <p><strong>Tracking Id :</strong>{{ singleEvent.data_tracking_id }}</p>
            <p><strong>Shipping Id :</strong>{{ singleEvent.data_shipping_id }}</p>
          </div>


          <div v-if="singleEvent.event_type=='customer-draft'">

            <div class="event-timeline-approval-status"><span>Approval Status: </span>{{ approvalStat }}</div>
            <p><strong>Is Email Sent :</strong>{{ singleEvent.data_mail_sent }}</p>
            <p><strong>Is SMS Sent :</strong>{{ singleEvent.data_sms_sent }}</p>

            <p v-if="singleEvent.data_customer_responded_at" class="text-info"><strong>Cust. Responded At :</strong> {{ moment(singleEvent.data_customer_responded_at).utc().format('DD-MM-YYYY, h:mm a')  }} UTC</p>

            <p><strong>How it's Sent :</strong>{{ singleEvent.data_how_its_done }}</p>

            <div v-for="draftFile in singleEvent.draft_files" :key="draftFile.id">
              <b-card
                :title="draftFile.fileName"
                :img-src="draftFile.file_info.fileThumbUrl"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 22rem;"
                class="mb-2 img-card m-t-20"
              >
                <b-card-text>
                  <p class="m-t-10 m-b-10"><strong>Approval Status :</strong> {{ draftFile.approval_status }}</p>
                </b-card-text>
                <b-button target="_blank" :href="draftFile.file_info.fileUrl" variant="primary">View Actual File</b-button>
              </b-card>
            </div>

          </div>

          <div v-if="singleEvent.event_type=='print-queue'">
             <p><strong>Item Name :</strong>{{ singleEvent.data_item_name }}</p>
             <p><strong>Item Record Id :</strong>{{ singleEvent.data_item_pk }}</p>
          </div>

          <div v-if="singleEvent.event_type=='notification'">
            <p><strong>Email Status: </strong> {{singleEvent.email_sending_status}}</p>
            <p><strong>SMS Status: </strong> {{singleEvent.sms_sending_status}}</p>
          </div>
          

          <p v-if="singleEvent.doer"><strong>Doer: </strong>{{singleEvent.doer}}</p>



          <div class="order-event-diff" v-if="calculatedDiff">
              Time Diff Frm Lst Evnt: {{ calculatedDiff }}
          </div>

      </div>

     
        


      
    </div>
  </li>
</template>

<script>
import moment from 'moment';

  export default {
     props: {
       singleEvent: {
         type: Object,
         default: () => ({})
       },
       indexKey: {
         type: Number,
         default: null
       },
       lastEventTime: {
         type: String,
         default: null
       }
     },
     computed: {
        calculatedDiff(){
           if(this.lastEventTime && this.singleEvent.event_time){

                var now  = moment(this.singleEvent.event_time);
                var then = moment(this.lastEventTime);

                var diff = moment.duration(now.diff(then));
                return `${Math.trunc(diff.asHours())} Hrs : ${Math.trunc(diff.minutes())} Mins : ${Math.trunc(diff.seconds())} Secs`;

           }else{
             console.log('Entered falsy')
             return false
           }
        },
        approvalStat(){
          let approved = 0;
          let notApproved = 0;
          let notTouched = 0;
          if(this.singleEvent.event_type == 'customer-draft'){
              this.singleEvent.draft_files.forEach(file => {
                  if(file.approval_status == 'Yes'){
                     approved++
                  }
                  else if(file.approval_status == 'No'){
                     notApproved++;
                  }
                  else if(file.approval_status == 'Not Touched'){
                     notTouched++;
                  }
              })
          }

          console.log(approved, notApproved, notTouched)

          if(approved == this.singleEvent.draft_files.length){
             return "All Approved"
          }
          else if(notApproved == this.singleEvent.draft_files.length){
             return "Non Approved"
          }
          else if(notApproved > 0 && approved > 0 && notTouched == 0){
             return "Mixed Approved & Disapproved"
          }
          else if(notTouched == this.singleEvent.draft_files.length){
              return "Not Touched Any"
          }
          else if(notTouched > 0 && (notApproved > 0 || approved > 0)){
              return "Partially Responsed"
          }
          else {
            return "Unknown"
          }
          
        }
     }
  }
</script>

<style lang="scss" scoped>

</style>